export const styleSheet = theme => ({
    container: {
        ...theme.content.blueButton,
        alignItems: 'center',
        borderRadius: 6,
        cursor: 'pointer',
        display: 'flex',
        minWidth: 30,
        height: 30,
        justifyContent: 'center',
        color: theme.colors.white01,
        p: {
            marginRight: 7,
            marginLeft: -2,
            paddingRight: 3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical'
        },
        svg: {
            marginTop: 1,
            marginLeft: 9,
            marginRight: 8.5,
            flexShrink: 0
        }
    },
    dropdownContainer: {
        margin: '10px 10px 0px 10px'
    },
    filterMenu: {
        ...theme.content.hoverMenu,
        width: 160,
        backgroundColor: theme.colors.white01
    },
    iconContainer: {
        width: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 8,
        marginBottom: 2,
        textAlign: 'center'
    },
    menuTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        letterSpacing: 1,
        padding: '10px 14px 10px 12px',
        backgroundColor: theme.colors.gray03
    },
    menuOption: {
        ...theme.content.hoverMenuOption,
        ':first-of-type': {
            borderRadius: 0
        }
    },
    dateRangeWrapper: {
        ...theme.content.hoverMenu,
        width: 350,
        height: 305,
        boxShadow: '0 6px 10px 0 rgba(0,0,0,0.2)',
        backgroundColor: theme.colors.white01
    },
    autocompleteMenu: {
        ...theme.content.hoverMenu,
        maxWidth: 230,
        boxShadow: '0 6px 10px 0 rgba(0,0,0,0.2)',
        backgroundColor: theme.colors.white01
    },
    autocomplete: {
        margin: theme.margins.margin00
    },
    menuHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    closeAutocomplete: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: theme.colors.gray06,
        p: {
            marginLeft: 6
        },
        ':hover': {
            color: theme.colors.black01,
            'svg g': {
                fill: theme.colors.black01
            }
        }
    },
    label: {
        ...theme.content.formLabel
    }
});
